/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AutoDecisioningSummaryCustomizedFacilitiesInner
 */
export interface AutoDecisioningSummaryCustomizedFacilitiesInner {
    /**
     * 
     */
    facility_id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    custom_change_count: number;
}

/**
 * Check if a given object implements the AutoDecisioningSummaryCustomizedFacilitiesInner interface.
 */
export function instanceOfAutoDecisioningSummaryCustomizedFacilitiesInner(value: object): value is AutoDecisioningSummaryCustomizedFacilitiesInner {
    if (!('facility_id' in value) || value['facility_id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('custom_change_count' in value) || value['custom_change_count'] === undefined) return false;
    return true;
}

export function AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSON(json: any): AutoDecisioningSummaryCustomizedFacilitiesInner {
    return AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSONTyped(json, false);
}

export function AutoDecisioningSummaryCustomizedFacilitiesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoDecisioningSummaryCustomizedFacilitiesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'facility_id': json['facility_id'],
        'name': json['name'],
        'custom_change_count': json['custom_change_count'],
    };
}

export function AutoDecisioningSummaryCustomizedFacilitiesInnerToJSON(json: any): AutoDecisioningSummaryCustomizedFacilitiesInner {
    return AutoDecisioningSummaryCustomizedFacilitiesInnerToJSONTyped(json, false);
}

export function AutoDecisioningSummaryCustomizedFacilitiesInnerToJSONTyped(value?: AutoDecisioningSummaryCustomizedFacilitiesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'facility_id': value['facility_id'],
        'name': value['name'],
        'custom_change_count': value['custom_change_count'],
    };
}

